import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleAuthProvider ,} from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getUserDataFromProvider } from "../handlers/handler"; 
import { checkAndCreateGuestProfile } from "../handlers/handler";
export const useSocialSignupAndLogin = () => {
  const [analytics, setAnalytics] = useState(undefined);
  const [loading, setLoading] = useState({
    google: false,
  });
  const [error, setError] = useState("");

  const navigate = useNavigate();


  useEffect(() => {
    isSupported().then((analyticsSupported) => {
      if (analyticsSupported) {
        const analyticsVar = getAnalytics();
        setAnalytics(analyticsVar);
      }
    });
  }, []);

  const handleGoogle = async ({ subscriptionType}) => {
    setError("");
    setLoading((prev) => ({ ...prev, google: true }));
    const googleProvider = new GoogleAuthProvider();
    const userRes = await getUserDataFromProvider(googleProvider);
    if (userRes.success && userRes.user) {
      const response = await checkAndCreateGuestProfile({ user: userRes.user });
      if (response?.success) {
        navigate("/");
            
      } else {
        setError(response?.error);
      }
    } else {
      setError(userRes?.error || userRes?.errorCode || "An unknown error occurred.");
      setLoading(false);
    }
 return userRes;
  };

  return {
    handleGoogle,
    socialLoading: loading,
    socialError: error,
  
  };
};
